<template>
  <div class="fill-height">
    <v-layout row wrap>
      <v-flex>
        <section>
          <v-img
            width="100%"
            height="100vh"
            alt="tvandroid"
            class="px-8"
            gradient="to top right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)"
            :src="app.bg[index_bg]">
            <v-row 
              align="center" 
              justify="center"
              style="height: 100vh;">
              <v-col 
                cols="12"
                md="3">
                <v-card
                  flat
                  color="transparent">
                  <div>
                    <div
                      class="mb-16">
                      <v-img 
                        contain
                        width="150"
                        height="150"
                        alt="tvandroid"  
                        :src="app.logo"
                        class="ma-auto">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </div>

                    <v-card
                      flat
                      color="#FFFFFFB2"
                      class="border-radius">
                      <v-card-text
                        class="pa-8">
                        <div
                          class="text-center mb-6">
                          <div
                            class="title font-weight-bold black--text mb-2">
                            Admin Login
                          </div>
                        </div>

                        <ValidationObserver 
                          ref="observer">
                          <v-form class="text-left mb-6">
                            <ValidationProvider 
                              name="email" 
                              rules="required|email" 
                              v-slot="{ errors }">
                              <v-text-field
                                v-on:keyup.enter="save"
                                class="no_box"
                                solo
                                :color="set_color"
                                placeholder="Email"
                                prepend-inner-icon="mdi-account-outline"

                                vv-uppercase

                                v-model="form.email"
                                :error-messages="errors"
                                required>
                              </v-text-field>
                            </ValidationProvider>

                            <ValidationProvider 
                              name="password" 
                              rules="required|min:5|max:20" 
                              v-slot="{ errors }">
                              <v-text-field
                                v-on:keyup.enter="save"
                                class="no_box"
                                solo
                                :color="set_color"
                                placeholder="Password"
                                :type="show ? 'text' : 'password'"
                                prepend-inner-icon="mdi-lock-outline"
                                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="show = !show"
                                :counter="20"

                                vv-uppercase
                                
                                v-model="form.password"
                                :error-messages="errors"
                                required>
                              </v-text-field>
                            </ValidationProvider>
                          </v-form>
                        </ValidationObserver>

                        <div 
                          class="text-center mb-6">
                          <div v-if="message.error.length > 0"
                            class="text-center my-4">
                            <div
                              class="error--text d-flex align-start">
                              <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                              
                              <span
                                class="ml-1">
                                {{ message.error }}
                              </span>
                            </div>
                          </div>

                          <v-btn
                            v-on:keyup.enter="save"
                            :disabled="process.form"
                            :loading="process.form"
                            @click="save"
                            block
                            x-large
                            width="170"
                            elevation="0"
                            class="title font-weight-bold white--text text-capitalize"
                            style="border-radius: 8px; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                            Login
                          </v-btn>
                        </div>

                        <div
                          class="body-2 text-center black--text">
                          Forgot password ?
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-img>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        show: false,

        app: {
          logo: require('@/assets/logo/favicon.png'),
          logo: require('@/assets/logo/favicon.png'),
          bg: [require('@/assets/background/bg_visuality.jpg')]
        },

        index_bg: 0,

        form: {
          email: '',
          password: '',
          fcm_token: ''
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      }
    },
    mounted () {
      let company = {
        company_name: 'VISUALITY',
        logo: require('@/assets/logo/logo_color.png')
      }

      TokenService.saveCompany(JSON.stringify(company))
      this.$store.commit("setCompany", company)

      TokenService.saveColor('#0786BE')
      this.$store.commit("setColor", '#0786BE')

      this.fetch()
    },
    methods: {
      fetch () {
        this.fetchLogo()
        this.fetchBg()
      },

      async fetchLogo () {
        let params = {
          key: 'APP_LOGO'
        }

        await get(`public/config/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.code === 200) {
            this.app.logo = res.result.data[0].value
          }
        })
      },

      async fetchBg () {
        let params = {
          key: 'APP_BACKGROUND_SLIDER_JSON'
        }

        await get(`public/config/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.code === 200) {
            this.app.bg = res.result.data[0].value_object.wallpaper

            setInterval(this.bg_time, 10000)
          }
        })
      },

      bg_time () {
        if (++this.index_bg >= this.app.bg.length)
        this.index_bg = 0
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true

          await post('public/login/admin', {
            data: this.form
          })
          .then(response => {
            let res = response.data

            if (res.code === 200) {
              let user = res.result.user,
                  menu = [
                    {
                      title: 'Dashboard',
                      icon: require('@/assets/icon/dashboard.png'),
                      link: '/dashboard',
                      active: true,
                      sub_menu: [],
                      type: 'parent'
                    },
                    {
                      title: 'Guest Room',
                      icon: require('@/assets/icon/guest.png'),
                      link: '/guest',
                      active: false,
                      sub_menu: [],
                      type: 'parent'
                    },
                    {
                      title: 'Food Order',
                      icon: require('@/assets/icon/order.png'),
                      link: '/order',
                      active: false,
                      sub_menu: [],
                      type: 'parent'
                    },
                    {
                      title: 'Services Request',
                      icon: require('@/assets/icon/service.png'),
                      link: '/service',
                      active: false,
                      sub_menu: [],
                      type: 'parent'
                    },
                    {
                      title: 'Facilities',
                      icon: require('@/assets/icon/facility.png'),
                      link: '/facility',
                      active: false,
                      sub_menu: [],
                      type: 'parent'
                    },
                    {
                      title: 'Hospital Services',
                      icon: require('@/assets/icon/nursing.png'),
                      link: '/nursing',
                      active: false,
                      sub_menu: [],
                      type: 'parent'
                    },
                    {
                      title: 'Nearby Attractions',
                      icon: require('@/assets/icon/attraction.png'),
                      link: '/attraction',
                      active: false,
                      sub_menu: [],
                      type: 'parent'
                    },
                    {
                      title: 'Food Menu',
                      icon: require('@/assets/icon/menu.png'),
                      link: '/food',
                      active: false,
                      sub_menu: [],
                      type: 'parent'
                    },
                    {
                      title: 'Hotel Services',
                      icon: require('@/assets/icon/room.png'),
                      link: '/room',
                      active: false,
                      sub_menu: [],
                      type: 'parent'
                    },
                    {
                      title: 'GM Greetings',
                      icon: require('@/assets/icon/greeting.png'),
                      link: '/greeting',
                      active: false,
                      sub_menu: [],
                      type: 'parent'
                    },
                    {
                      title: 'Text Rotator',
                      icon: require('@/assets/icon/text.png'),
                      link: '/text',
                      active: false,
                      sub_menu: [],
                      type: 'parent'
                    },
                    {
                      title: 'Room Type',
                      icon: require('@/assets/icon/linear_channel.png'),
                      link: '/category',
                      active: false,
                      sub_menu: [],
                      type: 'parent'
                    },
                    {
                      title: 'CCTV',
                      icon: require('@/assets/icon/cctv.png'),
                      link: '/cctv',
                      active: false,
                      sub_menu: [],
                      type: 'parent'
                    },
                    {
                      title: 'Extra Menu',
                      icon: require('@/assets/icon/extra_menu.png'),
                      link: '/extra',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Doa Harian',
                          icon: require('@/assets/icon/prayer.png'),
                          link: '/extra/prayer',
                          active: false,
                          sub_menu: []
                        },
                        {
                          title: 'Public Space',
                          icon: require('@/assets/icon/ads.png'),
                          link: '/extra/ads',
                          active: false,
                          sub_menu: []
                        },
                        {
                          title: 'Group Greeting',
                          icon: require('@/assets/icon/greeting.png'),
                          link: '/extra/greeting',
                          active: false,
                          sub_menu: []
                        },
                        {
                          title: 'Emergency',
                          icon: require('@/assets/icon/siren.png'),
                          link: '/extra/emergency',
                          active: false,
                          sub_menu: []
                        },
                      ],
                      type: 'parent_sub'
                    },
                    {
                      title: 'Setting',
                      icon: require('@/assets/icon/setting.png'),
                      link: '/setting',
                      active: false,
                      sub_menu: [
                        {
                          title: 'User',
                          icon: require('@/assets/icon/user.png'),
                          link: '/setting/user',
                          active: false,
                          sub_menu: []
                        },
                        {
                          title: 'Wallpaper',
                          icon: require('@/assets/icon/wallpaper.png'),
                          link: '/setting/wallpaper',
                          active: false,
                          sub_menu: []
                        },
                        {
                          title: 'Company',
                          icon: require('@/assets/icon/company.png'),
                          link: '/setting/company',
                          active: false,
                          sub_menu: []
                        },
                        {
                          title: 'Food Category',
                          icon: require('@/assets/icon/food_category.png'),
                          link: '/setting/foodcategory',
                          active: false,
                          sub_menu: []
                        },
                        {
                          title: 'Channel Category',
                          icon: require('@/assets/icon/channel_category.png'),
                          link: '/setting/channelcategory',
                          active: false,
                          sub_menu: []
                        },
                        {
                          title: 'Master Room',
                          icon: require('@/assets/icon/master.png'),
                          link: '/setting/master',
                          active: false,
                          sub_menu: []
                        },
                        {
                          title: 'Screensaver',
                          icon: require('@/assets/icon/screensaver.png'),
                          link: '/setting/screensaver',
                          active: false,
                          sub_menu: []
                        },
                        {
                          title: 'Promo',
                          icon: require('@/assets/icon/promo.png'),
                          link: '/setting/promo',
                          active: false,
                          sub_menu: []
                        },
                      ],
                      type: 'parent_title'
                    }
                  ]
                  
              if (user.user_role === 'superadmin' || user.user_role === 'admin_tv') {
                menu.splice(11, 0, {
                  title: 'Linear Channel',
                  icon: require('@/assets/icon/channel.png'),
                  link: '/channel',
                  active: false,
                  sub_menu: [],
                  type: 'parent'
                })

                // menu.splice(6, 0, {
                //   title: 'Linear Channel',
                //   icon: require('@/assets/icon/channel.png'),
                //   link: '/channel',
                //   active: false,
                //   sub_menu: [],
                //   type: 'parent'
                // })
              }

              if (user.user_role === 'superadmin') {
                menu[15].sub_menu.push({
                  title: 'App In App',
                  icon: require('@/assets/icon/app_in_app.png'),
                  link: '/setting/app',
                  active: false,
                  sub_menu: []
                })

                // menu[9].sub_menu.push({
                //   title: 'App In App',
                //   icon: require('@/assets/icon/app_in_app.png'),
                //   link: '/setting/app',
                //   active: false,
                //   sub_menu: []
                // })
              }

              TokenService.saveToken(
                res.result.data_token.token,
                JSON.stringify(user),
                JSON.stringify(menu)
              )

              TokenService.saveReload(false)

              window.location = `${process.env.BASE_URL}dashboard`
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      }
    }
  }
</script>